// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"moon-rising"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3.49903 15C3.49903 15 3.20173 14.2715 3.13507 14.0227C1.8486 9.22151 4.69784 4.28648 9.49903 3C9.14617 4.31269 9.19128 5.71513 9.56838 7.12252C10.7119 11.3903 15.0986 13.9229 19.3663 12.7794C19.8747 12.6432 20.3585 12.4609 20.8143 12.2383C20.7618 13.1057 20.499 14 19.999 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M2 19H9L12 17L15 19H22","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-moon-rising')
export default class MoonRisingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'moon-rising',
    }
  }
}
